// Detaillierte Inhalte für alle Ratgeber-Artikel

export const ratgeberContent = {
  'schliesszylinder-ausmessen': {
    sections: [
      {
        title: 'Warum ist das korrekte Ausmessen wichtig?',
        content: `Ein Schließzylinder ist das Herzstück Ihrer Tür-Sicherheit. Damit ein neuer Zylinder perfekt passt und Ihre Tür optimal schützt, ist das exakte Ausmessen unerlässlich. Ein falsch bemessener Zylinder kann nicht nur zu Funktionsproblemen führen, sondern auch die Sicherheit erheblich beeinträchtigen. Steht der Zylinder beispielsweise zu weit über, bietet er Einbrechern eine Angriffsfläche.

Bei zu kurzen Zylindern kann hingegen das Schloss nicht richtig greifen, was die Stabilität der Verriegelung mindert. In der Praxis sehen wir häufig, dass selbst gekaufte Zylinder aufgrund falscher Maße nicht passen – das kostet Zeit, Geld und Nerven. Mit unserer Schritt-für-Schritt-Anleitung vermeiden Sie diese Probleme.`
      },
      {
        title: 'Benötigtes Werkzeug',
        content: `Für das Ausmessen Ihres Schließzylinders benötigen Sie lediglich:
        
• Einen Zollstock oder ein Maßband (Genauigkeit: mindestens 1mm)
• Einen Kreuzschlitz-Schraubendreher (zum Lösen der Stiftschraube)
• Eventuell einen Inbusschlüssel (je nach Modell)
• Notizzettel und Stift zum Aufschreiben der Maße

Optional hilfreich sind eine Taschenlampe für bessere Sicht und eine zweite Person, die beim Herausziehen des Zylinders assistiert.`
      },
      {
        title: 'Schritt-für-Schritt-Anleitung zum Ausmessen',
        content: `**Schritt 1: Tür öffnen und Stiftschraube lösen**
Öffnen Sie die Tür vollständig. An der Stirnseite der Tür (dem Schlossstulp) befindet sich eine Schraube, die den Zylinder fixiert. Drehen Sie diese Schraube mit dem Schraubendreher heraus und legen Sie sie sicher beiseite.

**Schritt 2: Zylinder herausziehen**
Stecken Sie einen Schlüssel in den Zylinder und drehen Sie ihn leicht (etwa 10-20 Grad), um die inneren Stifte zu entriegeln. Ziehen Sie nun vorsichtig am Schlüssel, sodass der Zylinder aus der Tür gleitet. Achten Sie darauf, dass keine Teile herausfallen.

**Schritt 3: Gesamtlänge messen**
Messen Sie die komplette Länge des Zylinders von Ende zu Ende. Nicht die dekorativen Knäufe oder Beschläge mitmessen, sondern nur den eigentlichen Zylinderkörper.

**Schritt 4: Befestigungsschraube lokalisieren**
In der Mitte des Zylinders befindet sich ein Loch für die Befestigungsschraube (Stiftschraube). Diese Position markiert den Mittelpunkt.

**Schritt 5: Maße von der Stiftschraube messen**
Messen Sie nun jeweils von der Mitte der Befestigungsschraube bis zu beiden Enden:
- **Außenseite** (Straßenseite): Abstand von Schraubenloch bis zum Ende
- **Innenseite** (Wohnungsseite): Abstand von Schraubenloch bis zum Ende

Diese beiden Maße werden im Format "Außen/Innen" angegeben, beispielsweise 30/35 mm.

**Schritt 6: Überstandslänge prüfen**
Für optimale Sicherheit sollte der Zylinder bündig mit dem Beschlag abschließen oder maximal 3mm überstehen. Mehr Überstand bietet Einbrechern Angriffsfläche.`
      },
      {
        title: 'Häufige Fehler beim Ausmessen',
        content: `Viele Menschen machen beim Ausmessen typische Fehler, die später zu Problemen führen:

**Fehler 1: Beschlag mitmessen**
Der häufigste Fehler: Es wird nicht der Zylinder selbst gemessen, sondern inklusive der Beschläge oder Sicherheitsrosetten. Diese müssen ignoriert werden.

**Fehler 2: Falscher Nullpunkt**
Manche messen von einem Ende zum anderen und teilen dann durch zwei. Das funktioniert nur bei symmetrischen Zylindern, was selten der Fall ist.

**Fehler 3: Ungenaue Messung**
Ein Millimeter kann entscheidend sein. Messen Sie mehrfach und im Zweifel lieber zweimal nach.

**Fehler 4: Zylindertyp verwechseln**
Es gibt verschiedene Typen: Profil-Doppelzylinder, Knaufzylinder, Halbzylinder. Stellen Sie sicher, dass Sie den richtigen Typ nachbestellen.`
      },
      {
        title: 'Sonderformen und Spezialfälle',
        content: `Nicht alle Zylinder sind gleich. Hier einige Sonderformen:

**Knaufzylinder**: Eine Seite hat statt einem Schlüsselloch einen drehbaren Knauf. Hier wird nur die Schlüsselseite gemessen, der Knauf als "K" notiert (z.B. 30/K).

**Halbzylinder**: Nur eine Seite hat ein Schlüsselloch, wird von der Stiftschraube zum Ende gemessen.

**Langzylinder**: Bei sehr alten oder speziellen Türen können Zylinder deutlich länger sein. Standardlängen reichen bis etwa 100mm Gesamtlänge.

**Hebelzylinder**: Bei Rollgittern oder speziellen Schließsystemen. Benötigen spezielle Messmethoden.

Bei Unsicherheit empfehlen wir, den alten Zylinder auszubauen und zu unserem Service zu bringen oder ein Foto mit Maßangabe zu senden.`
      },
      {
        title: 'Professionelle Hilfe',
        content: `Sie sind unsicher beim Ausmessen oder trauen sich das Ausbauen nicht zu? Unser Service umfasst:

• Kostenlose Beratung am Telefon mit Messanleitung
• Vor-Ort-Aufmaß durch unseren Techniker
• Sofortige Lieferung und Einbau des passenden Zylinders
• Fachgerechte Entsorgung des alten Zylinders

Ein professionell ausgemessener und eingebauter Zylinder garantiert optimale Sicherheit und Funktion für viele Jahre. Bei Fragen rufen Sie uns einfach unter 0231 39085116 an – wir helfen gerne!`
      }
    ]
  },

  'tuerschloss-wechseln': {
    sections: [
      {
        title: 'Wann sollte ein Türschloss gewechselt werden?',
        content: `Es gibt verschiedene Gründe, warum ein Türschloss ausgetauscht werden sollte. Nach einem Einbruch oder Einbruchsversuch ist der Wechsel unbedingt erforderlich, da das Schloss beschädigt sein kann oder die Sicherheit kompromittiert wurde. Auch bei Verlust des Schlüssels sollten Sie nicht zögern – Sie wissen nie, ob der Schlüssel in falsche Hände gerät.

Ein weiterer häufiger Grund ist der Umzug in eine neue Wohnung. Hier wissen Sie nicht, wie viele Personen noch Schlüssel besitzen. Ein Schlosswechsel gibt Ihnen die Gewissheit, der einzige Schlüsselinhaber zu sein. 

Auch die normale Alterung spielt eine Rolle: Wenn das Schloss schwergängig wird, klemmt oder der Schlüssel sich schwer drehen lässt, ist oft ein Austausch sinnvoller als eine Reparatur. Moderne Schlösser bieten zudem deutlich bessere Sicherheitsstandards als Modelle, die älter als 10-15 Jahre sind.

Nicht zuletzt möchten viele Menschen ihr Sicherheitsniveau generell erhöhen und investieren daher in hochwertige Sicherheitsschlösser mit Mehrfachverriegelung oder elektronische Systeme.`
      },
      {
        title: 'Unterschied zwischen Schloss und Zylinder',
        content: `Viele Menschen verwechseln diese beiden Komponenten, dabei erfüllen sie unterschiedliche Funktionen:

**Der Schließzylinder** ist das Teil, in das Sie den Schlüssel stecken. Er enthält die Stifte, die den Schließmechanismus aktivieren. Der Zylinder allein lässt sich relativ einfach wechseln und ist die günstigere Variante.

**Das Einsteckschloss** (oft einfach "Schloss" genannt) ist der komplette Mechanismus im Inneren der Tür. Es beinhaltet Riegel, Falle und bei modernen Türen auch Mehrfachverriegelungen. Der Austausch des kompletten Schlosses ist aufwändiger und teurer.

In den meisten Fällen reicht der Wechsel des Zylinders aus – etwa nach Schlüsselverlust oder für ein Sicherheitsupgrade. Das komplette Schloss muss nur getauscht werden, wenn:
• Der Mechanismus defekt ist
• Sie auf Mehrfachverriegelung umrüsten möchten
• Das Schloss nicht mehr sicher schließt
• Beim Einbruch das gesamte Schloss beschädigt wurde`
      },
      {
        title: 'Werkzeug und Vorbereitung',
        content: `Für den Wechsel des Türschlosses benötigen Sie folgendes Werkzeug:

**Grundausstattung:**
• Kreuzschlitz-Schraubendreher (verschiedene Größen)
• Inbusschlüssel-Set
• Zollstock oder Maßband
• Bleistift zum Markieren
• Taschenlampe für bessere Sicht

**Für Einsteckschloss-Wechsel zusätzlich:**
• Stechbeitel (zum Erweitern von Ausschnitten)
• Bohrmaschine mit Holzbohrern
• Feile
• Hammer
• Wasserwaage

**Vorbereitung:**
Fotografieren Sie das alte Schloss aus verschiedenen Winkeln, bevor Sie beginnen. Diese Fotos helfen Ihnen später beim Zusammenbau und können wichtig sein, falls Sie professionelle Hilfe benötigen. Stellen Sie sicher, dass Sie genügend Zeit haben – planen Sie mindestens 1-2 Stunden ein. Legen Sie alle Kleinteile (Schrauben, Stifte) in eine Schale, damit nichts verloren geht.`
      },
      {
        title: 'Anleitung: Zylinderwechsel',
        content: `**Schritt 1: Stiftschraube entfernen**
Öffnen Sie die Tür vollständig. An der Stirnseite (Schlossstulp) finden Sie eine Schraube, die den Zylinder fixiert. Entfernen Sie diese mit einem Schraubendreher. Bei manchen Modellen sind es zwei Schrauben.

**Schritt 2: Zylinder herausziehen**
Stecken Sie den Schlüssel in den Zylinder und drehen Sie ihn leicht (10-20 Grad). Ziehen Sie vorsichtig am Schlüssel, sodass der Zylinder aus der Tür gleitet. Falls er klemmt, drehen Sie den Schlüssel etwas weiter und versuchen es erneut.

**Schritt 3: Neuen Zylinder vorbereiten**
Überprüfen Sie, ob der neue Zylinder die gleichen Maße hat. Stecken Sie einen Schlüssel ein und drehen Sie ihn wie beim Ausbau.

**Schritt 4: Einbau**
Schieben Sie den neuen Zylinder mit eingestecktem und leicht gedrehtem Schlüssel in die Tür. Achten Sie darauf, dass er gerade sitzt und vollständig eingeschoben ist.

**Schritt 5: Fixieren**
Drehen Sie den Schlüssel zurück in die neutrale Position und setzen Sie die Stiftschraube wieder ein. Ziehen Sie sie fest an, aber nicht überdrehen.

**Schritt 6: Funktion testen**
Testen Sie mehrfach von beiden Seiten: Schlüssel stecken, drehen, Tür öffnen und schließen. Prüfen Sie auch, ob der Riegel sanft ein- und ausfährt.`
      },
      {
        title: 'Anleitung: Komplettes Einsteckschloss wechseln',
        content: `Der Wechsel des gesamten Einsteckschlosses ist deutlich aufwändiger:

**Schritt 1: Beschläge entfernen**
Entfernen Sie Türgriffe und Rosetten auf beiden Seiten. Bei manchen Modellen müssen Sie zunächst Abdeckkappen abziehen, um an die Schrauben zu gelangen.

**Schritt 2: Zylinder ausbauen**
Bauen Sie den Schließzylinder wie oben beschrieben aus.

**Schritt 3: Stulpschrauben lösen**
An der Stirnseite der Tür finden Sie 2-4 Schrauben, die den Stulp (die Metallplatte) fixieren. Entfernen Sie diese.

**Schritt 4: Schloss herausziehen**
Ziehen Sie das Einsteckschloss vorsichtig aus der Tür. Bei Mehrfachverriegelungen kann dies kompliziert sein, da mehrere Teile verbunden sind.

**Schritt 5: Neues Schloss einsetzen**
Schieben Sie das neue Schloss in die Aussparung. Achten Sie auf die korrekte Ausrichtung – die Falle muss zur richtigen Seite zeigen.

**Schritt 6: Fixieren und montieren**
Setzen Sie den Stulp auf und schrauben Sie ihn fest. Bauen Sie Zylinder und Beschläge wieder ein.

**Wichtig:** Bei Mehrfachverriegelungen sollte der Einbau von einem Fachmann durchgeführt werden, da hier viele mechanische Komponenten exakt justiert werden müssen.`
      },
      {
        title: 'Häufige Probleme und Lösungen',
        content: `**Problem: Neuer Zylinder passt nicht**
Prüfen Sie die Maße erneut. Oft wurden falsche Werte notiert. Eventuell passt auch der Zylindertyp nicht (Knauf statt Doppelzylinder etc.).

**Problem: Schlüssel lässt sich schwer drehen**
Der Zylinder ist möglicherweise nicht ganz eingeschoben oder die Stiftschraube drückt dagegen. Lockern Sie die Schraube minimal.

**Problem: Riegel fährt nicht vollständig aus**
Das neue Schloss ist nicht exakt ausgerichtet. Lösen Sie die Stulpschrauben und justieren Sie nach.

**Problem: Tür schließt nicht mehr richtig**
Das Schließblech im Türrahmen passt eventuell nicht zum neuen Schloss. Hier muss nachgearbeitet oder ein passendes Schließblech montiert werden.

**Problem: Griff lässt sich nicht montieren**
Die Vierkantaufnahme passt nicht. Prüfen Sie, ob Schloss und Griff kompatibel sind (8mm oder 9mm Vierkant).

Bei anhaltenden Problemen empfehlen wir professionelle Hilfe. Ein falsch eingebautes Schloss ist nicht nur unpraktisch, sondern auch ein Sicherheitsrisiko.`
      },
      {
        title: 'Wann Sie einen Profi rufen sollten',
        content: `In folgenden Fällen ist professionelle Hilfe ratsam:

• Sie haben keine Erfahrung mit Heimwerkerarbeiten
• Es handelt sich um eine Sicherheitstür mit Mehrfachverriegelung
• Die Tür hat ein spezielles oder sehr altes Schloss
• Sie sind sich bei den Maßen unsicher
• Das Schloss soll zeitgleich mit einem Sicherheitsupgrade verbunden werden
• Sie benötigen eine Schließanlage (mehrere Türen mit einem Schlüssel)

Unser Service umfasst:
• Kostenlose Beratung zur Schloss-Auswahl
• Fachgerechter Einbau innerhalb von 30-60 Minuten
• Garantie auf Material und Einbau
• Entsorgung der alten Komponenten
• Einweisung in die Nutzung

Ein professionell eingebautes Sicherheitsschloss gibt Ihnen die Gewissheit, dass Ihr Zuhause optimal geschützt ist. Rufen Sie uns unter 0231 39085116 an – wir beraten Sie gerne!`
      }
    ]
  },

  'din-rechts-din-links': {
    sections: [
      {
        title: 'Was bedeuten DIN rechts und DIN links?',
        content: `Die Begriffe "DIN rechts" und "DIN links" bezeichnen die Anschlagsrichtung einer Tür und sind nach der deutschen Industrienorm DIN 107 definiert. Diese Norm ist wichtig für den Einbau von Türen, Schlössern, Schließblechen und Türbeschlägen. Eine falsche Bestimmung führt oft zu teuren Fehlbestellungen und Montageproblemen.

Die Unterscheidung ist besonders wichtig, wenn Sie:
• Eine neue Tür bestellen
• Beschläge oder Türgriffe kaufen
• Ein Türschloss austauschen
• Ein Schließblech montieren
• Mit Handwerkern kommunizieren

In der Praxis erleben wir häufig Verwechslungen, weil Menschen intuitiv von ihrer Perspektive ausgehen. Die DIN-Norm definiert jedoch eindeutig, wie die Bestimmung erfolgen muss.`
      },
      {
        title: 'So bestimmen Sie die Anschlagsrichtung richtig',
        content: `Die Bestimmung erfolgt immer aus der Richtung, **aus der die Tür zu Ihnen aufschwingt**. Hier die exakte Vorgehensweise:

**Schritt 1: Position einnehmen**
Stellen Sie sich so hin, dass die Tür zu Ihnen hin aufgeht – also auf der Seite, wo die Bänder (Scharniere) zu sehen sind.

**Schritt 2: Öffnungsrichtung beobachten**
Öffnen Sie nun die Tür. Schwingt sie nach rechts auf, handelt es sich um **DIN rechts**. Schwingt sie nach links auf, ist es **DIN links**.

**Merkhilfe:**
"Die Tür zeigt mir ihre Scharniere, und ich schaue, wohin der Türgriff zeigt."

**Beispiel Wohnungstür:**
Typischerweise öffnet sich Ihre Wohnungstür vom Treppenhaus in Richtung Wohnung. Sie stehen also im Treppenhaus, sehen die Bänder und beobachten, wohin die Tür schwingt.

**Beispiel Zimmertür:**
Stehen Sie im Flur und die Tür öffnet sich ins Zimmer? Dann stehen Sie bereits richtig. Öffnet die Tür vom Zimmer in den Flur? Dann müssen Sie ins Zimmer gehen.`
      },
      {
        title: 'Häufige Fehler und Verwechslungen',
        content: `**Fehler 1: Falsche Perspektive**
Viele Menschen stehen auf der falschen Seite der Tür. Sie müssen immer dort stehen, wo die Tür auf Sie zu schwingt, nicht wo sie von Ihnen weg geht.

**Fehler 2: Linke oder rechte Hand**
Manche denken, es hätte mit der Hand zu tun, mit der man die Tür öffnet. Das ist nicht korrekt. Es geht ausschließlich um die Schwingrichtung.

**Fehler 3: Von innen oder außen**
Die Begriffe "von innen" und "von außen" sind irreführend und nicht eindeutig. Deshalb gibt es die DIN-Norm.

**Fehler 4: Schiebetüren**
Bei Schiebetüren funktioniert diese Definition nicht. Hier gibt es eigene Bezeichnungen.

**Eselsbrücke:**
"Bänder sichtbar, Tür zu mir – schwingt sie rechts, DIN rechts dafür."

Wenn Sie unsicher sind, machen Sie ein Foto von der geöffneten Tür (sodass man die Bänder sieht) und schicken es uns. Wir bestimmen dann für Sie die korrekte Anschlagsrichtung.`
      },
      {
        title: 'Praktische Bedeutung beim Schlüsseldienst',
        content: `Für unsere Arbeit ist die korrekte Anschlagsrichtung in mehreren Situationen entscheidend:

**Bei der Schloss-Bestellung:**
Einsteckschlösser gibt es für rechts und links anschlagende Türen. Ein "falsches" Schloss kann mechanisch nicht richtig funktionieren, da Falle und Riegel in die falsche Richtung zeigen würden.

**Bei Schließblechen:**
Das Schließblech im Türrahmen muss zur Anschlagsrichtung passen, damit Falle und Riegel korrekt einrasten können.

**Bei Türbeschlägen:**
Manche hochwertigen Beschläge sind asymmetrisch gestaltet oder haben unterschiedliche Funktionen je nach Seite (z.B. Drückergarnituren mit Schlüsselrosette).

**Bei Sicherheitstechnik:**
Zusatzschlösser, Panzerriegel oder Querriegelschlösser müssen exakt zur Anschlagsrichtung passen, sonst lassen sie sich nicht montieren.

**Bei Mehrfachverriegelungen:**
Moderne Sicherheitstüren haben oft 3-5 Verriegelungspunkte. Die Mechanik ist komplex und muss zur Anschlagsrichtung passen.

Eine falsche Angabe führt zu:
• Fehlbestellungen und Rücksendungen
• Verzögerungen bei der Reparatur
• Zusätzlichen Kosten
• Im schlimmsten Fall zu Sicherheitslücken`
      },
      {
        title: 'Sonderfälle und Ausnahmen',
        content: `**Doppelflügelige Türen:**
Bei zweiflügeligen Türen wird jeder Flügel einzeln betrachtet. Der Standflügel (der normalerweise geschlossen bleibt) und der Gehflügel (der regelmäßig geöffnet wird) können unterschiedliche Anschlagsrichtungen haben.

**Pendeltüren:**
Türen, die in beide Richtungen schwingen können (z.B. in Restaurants), folgen nicht dieser Norm. Hier wird meist von "Pendeltür" gesprochen ohne Links-Rechts-Angabe.

**Schiebetüren:**
Bei Schiebetüren spricht man nicht von DIN rechts/links, sondern von der Laufrichtung oder Position der Laufschiene.

**Falttüren:**
Auch hier gelten eigene Bezeichnungen, abhängig davon, wo die Faltrichtung beginnt.

**Industrietüren und Tore:**
Große Toranlagen haben oft eigene Normierungen und Bezeichnungen.

**Internationale Unterschiede:**
Die DIN-Norm ist eine deutsche Norm. Im Ausland gibt es teilweise abweichende Definitionen. Bei importierten Türen oder Beschlägen sollte man dies berücksichtigen.`
      },
      {
        title: 'Checkliste für Ihre Bestellung',
        content: `Bevor Sie Türkomponenten bestellen, prüfen Sie:

□ Habe ich die Anschlagsrichtung nach DIN-Norm bestimmt?
□ Stand ich auf der richtigen Seite (Bänder sichtbar)?
□ Habe ich ein Foto zur Sicherheit gemacht?
□ Passt die Bestellung zu meiner Tür (Material, Maße, Funktion)?
□ Habe ich alle Maße korrekt aufgenommen?
□ Ist das Produkt für meine Anschlagsrichtung verfügbar?

**Tipp für Heimwerker:**
Markieren Sie mit einem Stück Klebeband die Innenseite der Tür und schreiben Sie "DIN rechts" oder "DIN links" drauf. So vergessen Sie es nicht, wenn Sie im Baumarkt oder online bestellen.

**Professionelle Beratung:**
Unsicher? Wir kommen gerne vorbei, bestimmen die Anschlagsrichtung und beraten Sie vor Ort. Besser einmal mehr gefragt als falsch bestellt. Bei uns gibt es keine dummen Fragen – nur teure Fehler, die wir gemeinsam vermeiden.

Rufen Sie uns an unter 0231 39085116 oder senden Sie uns ein Foto. Wir helfen Ihnen weiter!`
      }
    ]
  },

  'schluessel-abgebrochen': {
    sections: [
      {
        title: 'Warum brechen Schlüssel ab?',
        content: `Ein abgebrochener Schlüssel ist eine der häufigsten Notsituationen im Alltag. Die Ursachen sind vielfältig und oft eine Kombination mehrerer Faktoren:

**Material-Ermüdung:**
Schlüssel sind ständigen Belastungen ausgesetzt – Drehungen, Vibrationen, Temperaturschwankungen. Nach Jahren kann das Material ermüden und plötzlich nachgeben. Besonders betroffen sind alte Schlüssel aus minderwertigem Metall oder Nachschlüssel in schlechter Qualität.

**Verschleiß des Schlosses:**
Ein schwergängiges Schloss erhöht die Belastung auf den Schlüssel enorm. Wenn Sie beim Drehen viel Kraft aufwenden müssen, steigt das Risiko eines Bruchs. Rost, Schmutz oder ein defekter Mechanismus im Inneren sind häufige Ursachen.

**Falsche Handhabung:**
Ruckartige Bewegungen, zu viel Kraft oder das Drehen in die falsche Richtung können den Schlüssel überlasten. Auch das "Ruckeln" bei einem klemmenden Schloss ist gefährlich.

**Temperatureinflüsse:**
Im Winter werden Metalle spröder. Ein eiskalter Schlüssel in einem gefrorenen Schloss ist besonders bruchgefährdet. Auch starke Temperaturwechsel können das Material schwächen.

**Mindere Qualität:**
Billige Nachschlüssel vom Automaten oder aus weichen Materialien halten oft nicht lange. Original-Schlüssel vom Hersteller sind deutlich stabiler.`
      },
      {
        title: 'Erste Hilfe: Was Sie selbst tun können',
        content: `Wenn der Schlüssel abbricht, bewahren Sie Ruhe. Hier sind sofort umsetzbare Erste-Hilfe-Maßnahmen:

**Schritt 1: Nicht weiter drehen!**
Vermeiden Sie weitere Bewegungen am Schloss. Jeder zusätzliche Versuch kann das abgebrochene Stück tiefer ins Schloss drücken.

**Schritt 2: Situation analysieren**
• Wie weit ragt der Schlüssel noch heraus?
• Ist die Tür bereits geöffnet oder noch geschlossen?
• Haben Sie einen Ersatzschlüssel?
• Welche Werkzeuge haben Sie zur Hand?

**Wenn der Schlüssel noch etwas herausragt (2-3mm):**
• Nehmen Sie eine spitze Pinzette oder eine Zange
• Greifen Sie das herausragende Ende vorsichtig
• Ziehen Sie gerade und mit gleichmäßiger Kraft
• Nicht drehen oder wackeln – nur ziehen!

**Wenn der Schlüssel komplett im Schloss steckt:**
• Sprühen Sie etwas Kriechöl (WD-40) ins Schloss
• Warten Sie 5 Minuten
• Halten Sie das Schloss leicht schräg nach unten
• Klopfen Sie vorsichtig von oben auf das Schloss
• Mit etwas Glück rutscht das Stück heraus

**Improvisation mit Haushaltsgegenständen:**
• Laubsägeblatt oder Cuttermesser-Klinge in den Schlitz schieben
• Versuchen, das Schlüsselstück damit zu greifen
• Mit sehr viel Geduld kann dies funktionieren

**Wichtig:** Diese Methoden funktionieren nur bei günstigen Bedingungen. Bei modernen Sicherheitszylindern oder tief sitzenden Bruchstücken ist professionelle Hilfe nötig.`
      },
      {
        title: 'Was Sie auf keinen Fall tun sollten',
        content: `Diese häufigen Fehler können die Situation verschlimmern:

**Fehler 1: Mit Gewalt arbeiten**
Niemals mit Hammer, großen Werkzeugen oder roher Gewalt versuchen, den Schlüssel herauszubekommen. Sie beschädigen damit das Schloss irreparabel.

**Fehler 2: Weitere Gegenstände ins Schloss stecken**
Drähte, Nägel oder improvisierte Werkzeuge können abbrechen und das Problem vergrößern. Dann stecken mehrere Teile im Schloss.

**Fehler 3: Sekundenkleber verwenden**
Manche Menschen versuchen, das Schlüsselstück an ein anderes Stück zu kleben. Der Kleber läuft ins Schloss und macht es komplett unbrauchbar. Dann ist nicht nur der Schlüssel kaputt, sondern das gesamte Schloss muss ausgetauscht werden.

**Fehler 4: Hitze anwenden**
Der Gedanke, Metall durch Erhitzen auszudehnen, mag logisch klingen – führt aber zu verformten Schlössern und erhöht die Brandgefahr.

**Fehler 5: Zu lange experimentieren**
Nach 10-15 Minuten erfolgloser Versuche sollten Sie professionelle Hilfe rufen. Jeder weitere Versuch kann das Schloss beschädigen und die Reparatur teurer machen.

**Fehler 6: Unseriöse "Notdienste" anrufen**
Bei Panik rufen Menschen oft die ersten Nummern an, die sie finden. Unseriöse Anbieter nutzen Notsituationen aus und verlangen Wucherpreise. Wählen Sie einen lokalen, seriösen Schlüsseldienst mit transparenten Festpreisen.`
      },
      {
        title: 'Professionelle Schlüsselextraktion',
        content: `So gehen Profis vor:

**Spezialwerkzeug:**
Schlüsseldienste verwenden sogenannte "Schlüsselextraktoren" oder "Broken-Key-Extractor". Das sind speziell geformte Werkzeuge mit Widerhaken, die in das Schloss eingeführt werden und das Schlüsselstück greifen.

**Verschiedene Techniken je nach Situation:**

**Bei herausragenden Schlüsselstücken:**
Feinmechanische Zangen oder Präzisionswerkzeuge kommen zum Einsatz. Mit ruhiger Hand und viel Erfahrung lässt sich das Stück meist herausziehen.

**Bei tief sitzenden Bruchstücken:**
Der Techniker verwendet dünne, spezielle Haken-Werkzeuge. Diese werden seitlich am Schlüsselstück vorbei ins Schloss geschoben und dann gedreht, sodass sie hinter dem Bruchstück greifen.

**Mit Vibrationstechnik:**
Spezielle Vibrationsgeräte können das festsitzende Stück lockern. Kombiniert mit Kriechöl lässt es sich dann besser entfernen.

**Notfallplan:**
In seltenen Fällen, wenn alle Extraktions-Methoden scheitern, muss der Zylinder ausgebohrt werden. Das ist die letzte Option, da dann ein neuer Zylinder eingebaut werden muss.

**Zeitaufwand:**
In 80% der Fälle kann ein Profi den Schlüssel innerhalb von 10-20 Minuten extrahieren. Bei komplizierten Fällen kann es bis zu einer Stunde dauern.

**Kosten:**
Die Extraktion selbst kostet bei uns im Regelfall zwischen 50-95 Euro, abhängig vom Zeitaufwand und der Schwierigkeit. Ein kompletter Zylinderaustausch wäre teurer.`
      },
      {
        title: 'Vorbeugende Maßnahmen',
        content: `So verhindern Sie, dass Schlüssel abbrechen:

**Regelmäßige Wartung:**
• Sprühen Sie 2-3x pro Jahr Graphit-Spray ins Schloss (kein Öl!)
• Reinigen Sie den Schlüssel gelegentlich mit einer Bürste
• Achten Sie auf Rost oder Verfärbungen

**Qualität bei Nachschlüsseln:**
• Lassen Sie Nachschlüssel beim Fachhändler anfertigen
• Vermeiden Sie Billig-Automaten
• Original-Schlüssel sind die sicherste Wahl

**Richtige Handhabung:**
• Drehen Sie den Schlüssel immer mit gleichmäßiger, sanfter Kraft
• Keine ruckartigen Bewegungen
• Bei Widerstand nicht mit Gewalt arbeiten, sondern Ursache suchen

**Schloss in Stand halten:**
• Bei schwergängigem Schloss nicht aussitzen, sondern reparieren lassen
• Im Winter gefrorene Schlösser mit Enteiser behandeln, nicht mit Gewalt öffnen
• Schmutz und Sand regelmäßig entfernen

**Altersgrenze beachten:**
• Schlüssel älter als 15 Jahre sollten vorsorglich ersetzt werden
• Bei sichtbaren Rissen oder Verformungen sofort tauschen
• Halten Sie immer einen Ersatzschlüssel bereit

**Ersatzschlüssel deponieren:**
Hinterlegen Sie einen Ersatzschlüssel bei Vertrauenspersonen (Familie, Nachbarn). So können Sie im Notfall schnell reagieren, ohne auf den Schlüsseldienst warten zu müssen.`
      },
      {
        title: 'Notfall-Kontakt und schnelle Hilfe',
        content: `Wenn Ihr Schlüssel abgebrochen ist, helfen wir schnell:

**Unser Service:**
• Anruf unter 0231 39085116 – wir sind 24/7 erreichbar
• Transparente Festpreise vor Ort-Nennung am Telefon
• Anfahrt innerhalb 15-30 Minuten in Dortmund
• Professionelle Extraktion mit Spezialwerkzeug
• Falls nötig: Sofortiger Einbau eines neuen Zylinders
• Gleiche Schlüssel für alle Ihre Türen auf Wunsch

**Was Sie am Telefon gefragt werden:**
• Wo ist der Schlüssel abgebrochen? (Haustür, Wohnungstür, etc.)
• Ragt noch etwas heraus?
• Ist die Tür offen oder geschlossen?
• Haben Sie einen Ersatzschlüssel?
• Ihre Adresse und nächste Postleitzahl

**Kosten bei uns:**
Mo-Fr 08-20 Uhr: Ab 119 € inkl. Anfahrt und Extraktion
Sa-So: Ab 199 € inkl. Anfahrt und Extraktion

Bei Zylinderaustausch kommen die Materialkosten hinzu (ab ca. 40 € für Standard-Zylinder, Sicherheitszylinder ab 80 €).

**Keine Sorge:** Wir nennen Ihnen vor Arbeitsbeginn den genauen Preis. Keine versteckten Kosten, keine Überraschungen!`
      }
    ]
  },

  'tuer-zugefallen': {
    sections: [
      {
        title: 'Die häufigste Notsituation im Alltag',
        content: `Eine zugefallene Tür zählt zu den häufigsten Gründen für Anrufe beim Schlüsseldienst. Die Situation kennen viele: Kurz den Müll rausbringen, Klingel  drücken oder dem Nachbarn etwas bringen – und plötzlich fällt die Tür ins Schloss. Der Schlüssel liegt innen auf dem Tisch.

**Was genau ist passiert?**
Bei einer "zugefallenen" Tür ist nur die Falle eingerastet, nicht der Riegel. Die Falle ist der schräge Teil des Schlosses, der beim Zuziehen automatisch ins Schließblech springt. Im Gegensatz zur abgeschlossenen Tür (wo der Riegel vorgeschoben ist) lässt sich eine zugefallene Tür oft noch mit relativ schonenden Methoden öffnen.

**Typische Situationen:**
• Kurz vor die Tür, Windböe zieht Tür zu
• Kind hat von innen die Tür geschlossen
• Beim Müllrausbringen nicht aufgepasst
• Haustier hat gegen die Tür gedrückt
• Beim Tragen von Einkäufen Tür nicht festgehalten

**Der psychologische Faktor:**
Der erste Moment des Begreifens löst oft Panik aus. Man fühlt sich hilflos und unter Zeitdruck. Viele Menschen treffen dann übereilte Entscheidungen und rufen unseriöse Notdienste an, die horrende Summen verlangen.

**Wichtig zu wissen:**
Eine zugefallene Tür ist in den meisten Fällen binnen Minuten und ohne Schaden zu öffnen. Sie müssen weder die Tür eintreten noch das Schloss zerstören. Bewahren Sie Ruhe – Hilfe ist unterwegs!`
      },
      {
        title: 'Erste Maßnahmen: Was Sie selbst versuchen können',
        content: `Bevor Sie den Schlüsseldienst rufen, können Sie folgende Methoden versuchen – aber nur bei zugefallenen (nicht abgeschlossenen!) Türen:

**Methode 1: Die Plastikkarten-Technik**
Diese Methode funktioniert nur bei älteren, einfachen Schlössern:
• Nehmen Sie eine robuste Plastikkarte (alte EC-Karte, Kundenkarte – keine, die Sie noch brauchen)
• Schieben Sie die Karte zwischen Tür und Rahmen, etwa auf Höhe der Falle
• Schieben Sie die Karte bei gleichzeitigem Druck gegen die Tür nach innen
• Bewegen Sie die Karte ruckartig, um die Falle zurückzudrücken
• **Achtung:** Funktioniert nicht bei modernen Schlössern mit Fallenüberwachung

**Methode 2: Durch Kippfenster einsteigen**
Wenn ein Fenster gekippt ist:
• Prüfen Sie, ob es sich ganz öffnen lässt (von außen die Entriegelung greifen)
• Steigen Sie vorsichtig hinein (Verletzungsgefahr!)
• Nur bis zum 1. Stock und nur, wenn sicher!
• **Achtung:** Nachbarn könnten Einbruch vermuten und Polizei rufen

**Methode 3: Ersatzschlüssel holen**
• Haben Sie einen Ersatzschlüssel bei Nachbarn, Familie oder Freunden hinterlegt?
• Ist jemand zu Hause, der von innen öffnen kann?
• Kommt jemand in absehbarer Zeit nach Hause?

**Methode 4: Über Balkon/Terrasse (Erdgeschoss)**
Wenn Sie im Erdgeschoss wohnen und Balkon-/Terrassentür zugänglich ist:
• Prüfen Sie, ob diese Tür offen oder nur angelehnt ist
• Eventuell über Nachbarbalkon Zugang bekommen

**Was Sie NICHT tun sollten:**
• Die Tür mit Gewalt aufbrechen (teure Schäden)
• Auf Leitern klettern (Lebensgefahr!)
• Ins 2. OG oder höher einsteigen (Lebensgefahr!)
• Werkzeuge verwenden, die das Schloss beschädigen
• Stundenlang experimentieren (Zeitverschwendung)

Nach 10-15 Minuten erfolgloser Versuche sollten Sie professionelle Hilfe rufen.`
      },
      {
        title: 'Wie öffnet ein Profi die Tür?',
        content: `Ein erfahrener Schlüsseldienst öffnet zugefallene Türen in der Regel schonend und schnell:

**Spezialwerkzeug für zugefallene Türen:**
Profis verwenden spezielle "Türöffnungs-Sets" mit Werkzeugen wie:
• Mica-Folie (flexibles, stabiles Spezialblech)
• Türöffnungskarten aus gehärtetem Material
• Spezielle Haken und Drahtschlingen
• Je nach Schlosstyp auch Lockpicking-Werkzeuge

**Die gängigste Methode:**
**Schritt 1:** Der Techniker begutachtet das Schloss und den Türspalt
**Schritt 2:** Er wählt das passende Werkzeug (meist eine spezielle Öffnungsfolie)
**Schritt 3:** Das Werkzeug wird zwischen Tür und Rahmen geschoben
**Schritt 4:** Mit gezielten Bewegungen wird die Falle zurückgedrückt
**Schritt 5:** Die Tür öffnet sich – ohne Schäden

**Zeitaufwand:**
Bei einer einfachen zugefallenen Tür: 2-10 Minuten
Bei modernen Sicherheitsschlössern: 10-30 Minuten

**Schadenfreie Öffnung:**
In über 95% der Fälle bei zugefallenen Türen gelingt eine schadenfreie Öffnung. Nur bei Hochsicherheitsschlössern mit Fallenüberwachung kann es sein, dass der Zylinder ausgetauscht werden muss.

**Unterschied zu abgeschlossenen Türen:**
Bei einer abgeschlossenen Tür (Riegel vorgeschoben) ist die Öffnung aufwändiger. Hier muss meist der Zylinder aufgebohrt oder das Schloss gepickt werden. Das dauert länger und ist teurer.

**Sonderfall: Mehrfachverriegelung**
Moderne Sicherheitstüren mit Mehrfachverriegelung sind auch zugefallen schwieriger zu öffnen, da mehrere Punkte verriegelt sind. Hier braucht der Profi mehr Zeit und spezielles Wissen.`
      },
      {
        title: 'Kosten und Preisgestaltung',
        content: `Die Kosten für die Öffnung einer zugefallenen Tür variieren je nach Anbieter und Situation. Hier unsere transparenten Preise:

**Unsere Festpreise:**
• **Mo-Fr 08-20 Uhr:** 119 € (inkl. Anfahrt)
• **Sa-So ganztags:** 199 € (inkl. Anfahrt)
• **Feiertage:** 199 € (inkl. Anfahrt)

**Was ist inklusive?**
• Anfahrt in ganz Dortmund
• Arbeitszeit und Öffnung
• Mehrwertsteuer
• Keine versteckten Kosten

**Zusatzkosten nur bei:**
• Beschädigungen, die eine Reparatur nötig machen (z.B. Zylindertausch)
• Material für Reparaturen (wird vorher besprochen)

**Unseriöse Anbieter erkennen:**
Vorsicht bei Schlüsseldiensten, die:
• Keine Festpreise nennen
• Extrem günstige Lockangebote haben (z.B. "ab 19 €")
• Pauschalen "Wochenend-Zuschläge" von 200-300 € verlangen
• Am Telefon keine konkrete Auskunft geben
• Nicht lokal ansässig sind

**Tipps zur Kostenvermeidung:**
• Fragen Sie am Telefon nach dem Gesamtpreis
• Lassen Sie sich die Anfahrt bestätigen (soll kostenlos sein)
• Fragen Sie nach Festpreisen, nicht "ab-Preisen"
• Wählen Sie einen lokalen Anbieter (kürzere Anfahrt = günstiger)
• Bei Unsicherheit: Mehrere Anbieter vergleichen

**Zahlung:**
Wir akzeptieren Barzahlung, EC-Karte und Kreditkarte. Sie erhalten sofort eine ordentliche Rechnung mit ausgewiesener Mehrwertsteuer.`
      },
      {
        title: 'Vorbeugen: Nie wieder ausgesperrt',
        content: `Mit einigen einfachen Maßnahmen können Sie verhindern, dass Sie sich wieder aussperren:

**1. Ersatzschlüssel deponieren**
• Bei vertrauenswürdigen Nachbarn
• Bei Familie oder Freunden in der Nähe
• In einem sicheren Schlüsselsafe (z.B. neben der Tür)

**Achtung:** Schlüssel NICHT unter der Fußmatte, im Blumentopf oder über dem Türrahmen verstecken – das sind die ersten Orte, wo Einbrecher suchen!

**2. Schlüsselkasten mit Code**
• Kleiner Safe an sicherer Stelle neben der Tür
• Mit Zahlencode gesichert
• Wetterfest für Außenbereich
• Kosten: ca. 30-60 €

**3. Angewohnheiten ändern**
• Immer den Schlüssel mitnehmen, auch "nur kurz"
• Schlüssel an die Garderobe oder immer an den gleichen Ort legen
• Schlüsselanhänger mit Karabiner an Gürtel/Tasche befestigen
• Klingel oder Türstopper verwenden, wenn Tür offen bleiben soll

**4. Technische Lösungen**
• **Elektrisches Türschloss:** Öffnung per Code, App oder Fingerabdruck
• **Smart Lock:** Öffnung übers Smartphone
• **Codeschloss:** Öffnung per Zahlencode statt Schlüssel
• **Funkschloss:** Öffnung per Funksender

**Kosten für technische Lösungen:**
• Einfaches Codeschloss: ab 100 €
• Smart Lock (Nachrüstung): ab 200 €
• Professionelles Funk-System: ab 500 €

**5. Türfalle deaktivieren**
Bei Wohnungstüren (nicht Haustüren!) können Sie die Falle teilweise deaktivieren, sodass die Tür nur abgeschlossen werden kann. Das verhindert das Zufallen, verringert aber die Sicherheit.

**6. Regelmäßige Routine**
Entwickeln Sie eine feste Routine: Schlüssel immer in dieselbe Tasche, immer greifen bevor Sie die Tür zuziehen. Nach einigen Wochen wird dies zur Gewohnheit.`
      },
      {
        title: 'Notfall-Checkliste und schnelle Hilfe',
        content: `Wenn es passiert ist – unsere Notfall-Checkliste:

**Sofort-Maßnahmen:**
□ Ruhe bewahren – keine Panik
□ Prüfen: Ist die Tür nur zugefallen oder abgeschlossen?
□ Gibt es ein gekipptes Fenster?
□ Ist jemand zu Hause (Partner, Kinder, Mitbewohner)?
□ Habe ich irgendwo einen Ersatzschlüssel?
□ Kann jemand in absehbarer Zeit einen Schlüssel bringen?

**Wenn Sie Hilfe brauchen:**
□ Rufen Sie uns an: 0231 39085116 (24/7 erreichbar)
□ Geben Sie Ihre genaue Adresse an
□ Beschreiben Sie die Situation (zugefallen oder abgeschlossen)
□ Fragen Sie nach dem Festpreis
□ Wir nennen Ihnen die voraussichtliche Ankunftszeit (meist 15-30 Min)

**Was wir am Telefon von Ihnen wissen möchten:**
• Ist die Tür nur zugefallen oder abgeschlossen?
• Welche Art von Tür (Wohnungstür, Haustür, Sicherheitstür)?
• Ihre genaue Adresse und Postleitzahl
• Gibt es Besonderheiten (Mehrfachverriegelung, Sicherheitszylinder)?

**Was wir Ihnen am Telefon sagen:**
• Den exakten Festpreis für Ihre Situation
• Die voraussichtliche Ankunftszeit
• Ob eine schadenfreie Öffnung möglich ist
• Was Sie bis dahin tun (oder nicht tun) sollten

**Unser Service:**
✓ Schnelle Anfahrt (15-30 Min in Dortmund)
✓ Transparente Festpreise
✓ Schadenfreie Öffnung in über 95% der Fälle
✓ Barzahlung, EC-Karte oder Kreditkarte
✓ Ordentliche Rechnung mit MwSt
✓ Freundliche, professionelle Techniker
✓ Lokales Unternehmen aus Dortmund

Speichern Sie unsere Nummer: **0231 39085116** – dann sind Sie für den Notfall gerüstet!`
      }
    ]
  }
};

// Weitere Ratgeber werden in Teil 2 fortgesetzt...
